import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ChatTongole from "../../common/ChatTongle";
import DownloadNotice from "../../common/downloadNotice";
import GameInner from "../../common/GameInner";
import JackpotRoot from "../../common/JackpotRoot";
import NoticeRoot from "../../common/NoticeRoot";
import Footer from "../../layout/Mobile/Footer";
import MobileHeaderInner from "../../layout/Mobile/MobileHeaderInner";
import MobileHomeSlider from "../../sliders/Mobile/MobileHomeSlider";
import FreeSpinLauncher from "../../free-spin/FreeSpinLauncher";

function MobileHome({globalData, triggerPrivateRefresh, sociallink} ) {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  // Simple auth + platform flags
  const isLoggedIn = Boolean(localStorage.getItem('token')) && Boolean(localStorage.getItem('remote_id'));
  const isMobile = true; // this page is for mobile; adjust if desktop detection is needed
   const [activeKey, setActiveKey] = useState("hot");
   const [language, setLanguage] = useState('English');
   const [selectedBrand, setSelectedBrand] = useState('localhost');

   console.log("selectedBrand", selectedBrand);

   const CloseTabBar = () => {
   
  const aside = document.querySelector('.sidebar');
  if (aside) {
    aside.classList.remove('main-nav-open');
  } else {
    console.warn("Sidebar element not found while trying to close tab bar");
  }
};
const handleChatClick = (e) => {
    e.preventDefault();
		// brodcast event to open chat
		window.dispatchEvent(new CustomEvent('open_chat', { detail: { foo: 'bar' } }));
  };
const origin = window.location.origin.replace(/^https?:\/\/(www\.)?/, '').replace(/(\.com|\.live|\.net|\.world)$/i, '');
const isMalik88 = origin.includes('malik88');
const isTk24 = origin.includes('tk24') || window.location.hostname.includes('tk24');
// Derive affiliate site URL: prefer configured base, else use subdomain 'affiliate.' + current hostname
const hostnameNoWww = window.location.hostname.replace(/^www\./, '');
const affiliateBase = localStorage.getItem('affiliate_site') || process.env.REACT_APP_AFFILIATE_BASE;
const affiliateUrl = (affiliateBase && affiliateBase.startsWith('http'))
  ? affiliateBase
  : `https://affilaite.${hostnameNoWww}`;
  // Detect live chat from API and props
  const [hasLiveChatData, setHasLiveChatData] = useState(false);
  const normalizeTruthy = (val) => {
    if (val === null || val === undefined) return false;
    if (typeof val === 'string') {
      const s = val.trim().toLowerCase();
      return s !== '' && s !== 'null' && s !== 'undefined' && s !== 'false';
    }
    return Boolean(val);
  };
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await fetch('https://api2b.pro/api/general');
        if (!res.ok) throw new Error('general api failed');
        const payload = await res.json();
        const item = Array.isArray(payload) ? payload[0] : payload;
        const has = [
          item?.live_chat,
          item?.livechat,
          item?.liveChat,
          item?.intercom,
          item?.tawk_id,
          item?.tawkId,
        ].some(normalizeTruthy);
        if (mounted) setHasLiveChatData(Boolean(has));
      } catch (e) {
        if (mounted) setHasLiveChatData(false);
      }
    })();
    return () => { mounted = false; };
  }, []);
  // Action visibility based on provided data and API
  const hasLiveChat = Boolean(
    hasLiveChatData || (
      sociallink && (
        (typeof sociallink.livechat === 'string' ? sociallink.livechat.trim() : sociallink.livechat) ||
        (typeof sociallink.liveChat === 'string' ? sociallink.liveChat.trim() : sociallink.liveChat) ||
        (typeof sociallink.live_chat === 'string' ? sociallink.live_chat.trim() : sociallink.live_chat) ||
        (typeof sociallink.cs24 === 'string' ? sociallink.cs24.trim() : sociallink.cs24)
      )
    )
  );
  const hasWhatsApp = Boolean(sociallink && sociallink.whatsapp);
  const hasTelegram = Boolean(sociallink && sociallink.telegram);
  const hasFacebook = Boolean(sociallink && sociallink.facebook);
  const menuItems = [
    { key: "SLOT", className: "vendor-nav-item RNG", name: "Slots", icon: "/icons/nav/nav-slot-color.svg" },
    { key: "FH", className: "vendor-nav-item FISH", name: "Fish", icon: "/icons/nav/nav-fish-color.svg" },
    { key: "LIVE", className: "vendor-nav-item LIVE", name: "Live", icon: "/icons/nav/nav-live-color.svg" },
    { key: "sports", className: "vendor-nav-item SPORTS", name: "Sports", icon: "/icons/nav/nav-sport-color.svg" },
    { key: "Crash", className: "vendor-nav-item ESPORTS", name: "EGAME", icon: "/icons/nav/nav-egame-color.svg" },
    { key: "TABLE", className: "vendor-nav-item COCKFIGHT", name: "Table", icon: "/icons/nav/nav-table-color.svg" },
    { key: "BINGO", className: "vendor-nav-item PVP", name: "Poker", icon: "/icons/nav/nav-poker-color.svg" },
    { key: "LOTTO", className: "vendor-nav-item ELOTTO", name: "Lottery", icon: "/icons/nav/nav-lottery-color.svg" },
  ];
   const translatePage = (lang) => {
        const googleTranslateElement = document.querySelector('.goog-te-combo');
        if (googleTranslateElement) {
            const langCode = lang === 'Bangla' ? 'bn' : 'en'; // Set the language code
            googleTranslateElement.value = langCode;
            googleTranslateElement.dispatchEvent(new Event('change')); // Trigger change event
        }
        setLanguage(lang); // Update the selected language
      
    };
    const flagSrc =
  language === 'English'
    ? 'https://images.394993282.com/TCG_PROD_IMAGES/COUNTRY_FLAG/CIRCLE/US.svg'
    : 'https://images.394993282.com/TCG_PROD_IMAGES/COUNTRY_FLAG/CIRCLE/BD.svg';

 useEffect(() => {
    const hostname = (window.location.hostname || '').toLowerCase();
    const origin = (window.location.origin || '').toLowerCase();
    const search = (window.location.search || '').toLowerCase();
    const params = new URLSearchParams(window.location.search);
    const brand = ((process.env.REACT_APP_BRAND || localStorage.getItem('brand') || '')).toLowerCase();

    const isBeetbuzz = hostname.includes('beetbuzz') || origin.includes('beetbuzz') || brand.includes('beetbuzz');
    const isLocalhost = hostname.includes('localhost') || origin.includes('localhost') || brand.includes('localhost');
    const isBk8bd = hostname.includes('bk8bd') || origin.includes('bk8bd') || brand.includes('bk8bd');
    const isCb444 = hostname.includes('cb444') || origin.includes('cb444') || brand.includes('cb444');
    const isjw88 = hostname.includes('jw88') || origin.includes('jw88') || brand.includes('jw88');
    const isCk4 = hostname.includes('ck4') || origin.includes('ck4') || brand.includes('ck4');
    const isSk444 = hostname.includes('sk444') || origin.includes('sk444') || brand.includes('sk444');

    const selectedBrand = isSk444 ? 'sk444': isCk4 ? 'ck4' : isjw88 ? 'jw88' : isBeetbuzz ? 'beetbuzz' : isLocalhost ? 'localhost' : (isBk8bd || isCb444) ? 'bk8bd' : 'default';

    localStorage.setItem('brand', selectedBrand);
    setSelectedBrand(selectedBrand);
  
    
  
  
   
  }, []);

  const handleGameClicks = async (gameCode, gamePlatform, gameType) => {

        if (selectedBrand === "beetbuzz") {
    // force always open saba
    gameCode = "SABA-VIRTUAL-001";
    gamePlatform = "SABA";
    gameType = "VIRTUAL";
  }
       
        if (!isLoggedIn) {
            navigate('/login');
            return;
        }
    
        const token = localStorage.getItem('token');
        const remote_id = localStorage.getItem('remote_id');
    
        if (!token || !remote_id) {
            setError('User not logged in');
            return;
        }
    
        setIsLoading(true);
    
        try {
            if (gamePlatform === 'Lucky') {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/player-login`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        user_id: remote_id,
                    }),
                });
    
                const dataly = await response.json();
                console.log(`https://sprodm.uni247.xyz/?access_token=${dataly.access_token}`);
                navigate('/gamerun', {
                    state: {
                        iframeUrl: `https://sprodm.uni247.xyz/?access_token=${dataly.access_token}`,
                    },
                });
    
                return; 
            }
    
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/inr-game-run`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({
                    userId: remote_id,
                    externalURL: origin,
                    isMobileLogin: isMobile,
                    gameCode: gameCode,
                    gameType: gameType,
                    platform: gamePlatform,
                }),
            });
    
            const data = await response.json();
    
            if (response.ok) {
              const url = data?.url || data?.data?.payload?.game_launch_url;
              if (url) {
                navigate('/gamerun', { state: { iframeUrl: url } });
              } else {
                setError(data.message || 'An unexpected error occurred');
              }
            } else {
              setError(data.message || 'An unexpected error occurred');
            }
        } catch (error) {
            setError('An unexpected error occurred');
        } finally {
            setIsLoading(false);
        }
    };

  return (
  <div data-reactroot>
  <div>
    <div id="mc-animate-container" className="v-base v-detail-base fade-enter-done">
      <div className="_container_box">
       <DownloadNotice/>
        <div className="home-container app-main avoid-footer">
        <MobileHeaderInner userData={globalData.userData} refreshPrivateData={triggerPrivateRefresh}/>
          <div className="banner-notice">
          <MobileHomeSlider SliderMain={globalData.sliders?.main || []} />
            <NoticeRoot globalData={globalData}/>
          </div>
           { selectedBrand === 'beetbuzz'
                  ? (
                    <></>
                  ) : (
                  <JackpotRoot/>
                  )}
          <div className="home-content-wrap" id="home-content">
             <GameInner  slidersFeatures={globalData.sliders?.feature || []} tabKey={activeKey}/>
         
          </div>
          <div className="footer-menu">
            <div className="footer-menu-bg">
              <div className="footer-menu-item on">
                <div className="footer-icon"><img src="/icons/footer/footer-home.svg" alt="Home" /></div>
                <span className="footer-menu-name">Home</span>
              </div>
              <Link to={"/promotion"} className="footer-menu-item">
                <div className="footer-icon"><img src="/icons/footer/footer-promotion.svg" alt="Promotion" /></div>
                <span className="footer-menu-name">Promotion</span>
              </Link>
              <Link to={"/deposit"} className="footer-menu-item deposit">
                <div className="footer-icon-bg">
                  <div className="footer-icon"><img src="/icons/footer/footer-deposit.svg" alt="Deposit" /></div>
                  <span className="footer-menu-name">Deposit</span>
                </div>
              </Link>
              <Link to={"/referral"} className="footer-menu-item">
                <div className="footer-icon invite"><img src="/icons/footer/footer-invite.svg" alt="Invite" /></div>
                <span className="footer-menu-name">Invite</span>
              </Link>
              <Link to={"/member"} className="footer-menu-item">
                <div className="footer-icon"><img src="/icons/footer/footer-member.svg" alt="Member" /></div>
                <span className="footer-menu-name">Member</span>
              </Link>
            </div>
          </div>
          { selectedBrand === 'beetbuzz' || selectedBrand === 'jw88' || selectedBrand === 'ck4'
      ? (
          <ChatTongole/>
        ) : (
    <div className="float-service">
      {hasLiveChat && selectedBrand !== 'sk444' && selectedBrand !== 'bk8bd' && (
        <div onClick={handleChatClick} className="service-item">
          <div className="service-icon">
            <svg className="am-icon am-icon-side-custom_aa2d6707 am-icon-md">
              <use xlinkHref="#side-custom_aa2d6707" />
            </svg>
          </div>
          <span>24CS</span>
        </div>
      )}

      {/* WhatsApp should be visible even for malik88 */}
      {hasWhatsApp && (
        <a href={sociallink.whatsapp} className="service-item">
          <div className="service-icon">
            <svg style={{fill: '#fff'}} className="am-icon am-icon-side-telegram_ee46c2fe am-icon-md">
              <use xlinkHref="#icon-whatsapp_64303883" />
            </svg>
          </div>
          <span>WhatsApp</span>
        </a>
      )}

      {/* Hide Telegram and Facebook for malik88, sk444, and bk8bd; also require data presence */}
      {!isMalik88 && selectedBrand !== 'sk444' && (
        <>
          {hasTelegram && (
            <a href={sociallink.telegram} className="service-item">
              <div className="service-icon">
                <svg className="am-icon am-icon-side-telegram_ee46c2fe am-icon-md">
                  <use xlinkHref="#side-telegram_ee46c2fe" />
                </svg>
              </div>
              <span>Telegram</span>
            </a>
          )}

          {hasFacebook && (
            <a href={sociallink.facebook} className="service-item">
              <div className="service-icon">
                <svg className="am-icon am-icon-side-facebook_75d5a945 am-icon-md">
                  <use xlinkHref="#side-facebook_75d5a945" />
                </svg>
              </div>
              <span>Facebook</span>
            </a>
          )}
        </>
      )}

      
    </div>
  )
}

    {/* Floating Free Spin launcher */}
    {!isTk24 && <FreeSpinLauncher visible={true} label="Free Spin" isLoggedIn={Boolean(localStorage.getItem('token'))} />}

          
        </div>
        <div className="sidebar">
          <div className="left-side-menu">
            <div className="side-menu-content hide-scrollbar">
  <div className="side-nav-layout">
    <div className="vendor-nav-wrap">
      <div onClick={() => CloseTabBar()} className="vendor-nav-item HOME on"><img className="auto-icon vendor-item-icon" src="/icons/nav/nav-home-color.svg" alt="Home" loading="lazy" /><span className="item-name">Home</span></div>
       {menuItems.map((item) => (
      <div className={` ${item.className}`}  onClick={() => {
      if (selectedBrand === 'beetbuzz' && item.key === 'sports') {
        handleGameClicks();
      } else {
        setActiveKey(item.key);
        CloseTabBar();
      }
    }}>
        <img className="auto-icon vendor-item-icon"  src={item.icon}
                        alt={item.name} loading="lazy" />
                        <span className="item-name">{item.name}</span>
                        </div>
       ))}
     
    </div>
  </div>
     
  <Link to={'/bettingRecord'} className="side-nav-layout">
    <div className="nav-bet"><img className="auto-icon vendor-item-icon" src="/icons/nav/nav-bet-color.svg" alt="Betting Record" loading="lazy" style={{width:'0.44rem',height:'0.44rem'}} /><span className="member-nav-name">Betting Record</span></div>
  </Link>
  <div className="side-nav-layout">
    <div className="member-nav-box member-nav-icon-mode">
      <Link to="/rebateBonus" className="member-nav-item">
        <div className="nav-icon-wrap"><img src="/icons/nav/nav-rebate-color.svg" alt="Rebate" /></div>
        <div className="nav-text">Rebate</div>
      </Link>
      <Link to="/rewardcenter" className="member-nav-item">
        <div className="nav-icon-wrap"><img src="/icons/nav/nav-reward-color.svg" alt="Reward" /></div>
        <div className="nav-text">Reward</div>
      </Link>
      <Link to="/referral" className="member-nav-item invite">
        <div className="nav-icon-wrap"><img src="/icons/nav/nav-invite-color.svg" alt="Invite" /></div>
        <div className="nav-text">Invite friends</div>
      </Link>
      <Link to="/promotion" className="member-nav-item promo">
        <div className="nav-icon-wrap"><img src="/icons/nav/nav-promo-color.svg" alt="Promotion" /></div>
        <div className="nav-text">Promotion</div>
      </Link>
    </div>
  </div>
  
  <div className="side-main-nav">
  
   <div
  className="side-nav-item"
  onClick={() =>
    translatePage(language === 'English' ? 'Bangla' : 'English')
  }
  style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}
>
  <img
    src={`https://images.394993282.com/TCG_PROD_IMAGES/COUNTRY_FLAG/CIRCLE/${
      language === 'English' ? 'US' : 'BD'
    }.svg`}
    alt={language}
    className="side-nav-icon"
  />
  <span>{language}</span>
</div>

    <a  href={`./app/${origin}.apk`} className="side-nav-item"><img className="auto-icon side-nav-icon" src="/icons/nav/nav-download-color.svg" alt="Download" loading="lazy" /><span>APP Download</span></a>
    <a href={affiliateUrl} className="side-nav-item" target="_blank" rel="noopener noreferrer">
      <img className="auto-icon side-nav-icon" src="/icons/nav/nav-affiliate-color.svg" alt="Affiliate" loading="lazy" />
      <span>Affiliate</span>
    </a>
  </div>
</div>

          </div>
          <div onClick={() => CloseTabBar()} className="sidebar-mask" />
        </div>
       
      </div>
    </div>
  </div>
  <div>
   
{selectedBrand === 'beetbuzz' ? (
    <></>
) : (
    <Footer />
)}

    
    <svg aria-hidden="true" focusable="false" style={{width: '0px', height: '0px', position: 'absolute'}}>
      <linearGradient id="t4-gradient-icon" x1={0} y1={0} x2={0} y2={1}>
        <stop offset={0} stopColor="#FEEF83" />
        <stop offset="0.5" stopColor="#FFFAC2" />
        <stop offset="0.75" stopColor="#E49612" />
        <stop offset={1} stopColor="#FED019" />
      </linearGradient>
    </svg>
  </div>
  <div className="layout-contents">
    <div id="mini-game-container" className="mini-game-container needsclick react-draggable" style={{transform: 'translate(0px)'}} />
  
  </div>
</div>

  );
}

export default MobileHome;
